var ArticlesVisibilitySettingsBuilder = /** @class */ (function () {
    function ArticlesVisibilitySettingsBuilder() {
        this.articlesVisbilitySettings = {
            types: [],
            categoryIds: [],
            excludedCategoryIds: [],
            hasAnyOfLabelIds: [],
            notHasAnyOfLabelIds: [],
            hasAllOfLabelIds: []
        };
    }
    ArticlesVisibilitySettingsBuilder.prototype.withTypes = function (types) {
        this.articlesVisbilitySettings.types = types;
        return this;
    };
    ArticlesVisibilitySettingsBuilder.prototype.withCategoryIds = function (categoryIds) {
        this.articlesVisbilitySettings.categoryIds = categoryIds;
        return this;
    };
    ArticlesVisibilitySettingsBuilder.prototype.withExcludedCategoryIds = function (excludedCategoryIds) {
        this.articlesVisbilitySettings.excludedCategoryIds = excludedCategoryIds;
        return this;
    };
    ArticlesVisibilitySettingsBuilder.prototype.withHasAllOfLabelIds = function (hasAllOfLabelIds) {
        this.articlesVisbilitySettings.hasAllOfLabelIds = hasAllOfLabelIds;
        return this;
    };
    ArticlesVisibilitySettingsBuilder.prototype.withHasAnyOfLabelIds = function (hasAnyOfLabelIds) {
        this.articlesVisbilitySettings.hasAnyOfLabelIds = hasAnyOfLabelIds;
        return this;
    };
    ArticlesVisibilitySettingsBuilder.prototype.withNotHasAnyOfLabelIds = function (notHasAnyOfLabelIds) {
        this.articlesVisbilitySettings.notHasAnyOfLabelIds = notHasAnyOfLabelIds;
        return this;
    };
    ArticlesVisibilitySettingsBuilder.prototype.build = function () {
        return this.articlesVisbilitySettings;
    };
    return ArticlesVisibilitySettingsBuilder;
}());
export { ArticlesVisibilitySettingsBuilder };
//# sourceMappingURL=articles-visibility-settings.builder.js.map